export class TranslationModel {
    /**
   * The identifier of the item
   */
    id: number;
  
    /**
     * The description of the item
     */
    description: string;

       /**
     * Translation of the item
     */
    translation: string;
  }
  